import React, { useState } from 'react';
import { Slider, Typography, Box } from '@mui/material';
import './Slider.scss';
import { MAX_REPOSTS } from './PostsandSearch';

const RepostsRangeSlider = ({repostsRange, setRepostsRange}) => {

    const handleChange = (event, newValue) => {
        setRepostsRange(newValue);
    };

    const formatValue = (value) => {
        return value >= 1000 ? `${(value / 1000).toFixed(1)}K` : value;
    };

    return (
        <Box className="slider-container">
            <Slider
                value={repostsRange}
                onChange={handleChange}
                valueLabelDisplay="auto"
                min={0}
                max={MAX_REPOSTS}
            />
            <Box className="values-display">
                <Typography>{formatValue(repostsRange[0])}</Typography>
                <Typography>{formatValue(repostsRange[1])}</Typography>
            </Box>
        </Box>
    );
};

export default RepostsRangeSlider;